import { HalfModifierSelection, Modals } from "../../../../../types/enums";
import { CustomizeItemUIBase, ICustomizeItemUiParams } from "../base/customize-item-ui-base";
import { Util } from "../../../../../utils/util";

export class CustomizeItemUISingleItem extends CustomizeItemUIBase {
    constructor(params: ICustomizeItemUiParams) {
        super({
            modalId: "modal_customize_item",
            eventBus: params.eventBus,
            data: params.data,
            context: params.context,
            localizationService: params.localizationService,
            order: params.order,
            dataLayerService: params.dataLayerService,
            profileService: params.profileService,
            modalName: Modals.CUSTOMIZE_ITEM,
            core: params.core,
            favorite: params.favorite
        });
    }

    override _renderPage(isFirstRender: boolean = false): void {
        Util.hideElement("div_customize_item_half_half");
        super._renderPage(isFirstRender);
    }

    protected override _hideAndShowPreModifierMultiButtonsCheckbox(modifierDisplayGroupId: number | null, modifierId: number, halfId: HalfModifierSelection): void { return; }
    protected override _hideAndShowPreModifierButtonsRadio(modifierDisplayGroupId: number | null, modifierId: number, halfId: HalfModifierSelection): void { return; }
}